import Plan from "./Plan"; 
const InvestmentPlan  = ({toDeposit}) =>{
    return (
        <>
            <div>
                <h1 className = 'text-3xl text-center capitalize text-bold font-medium py-[5%] sm:py-4'> The best Investment Plan </h1>
                <p className = "text-center px-1 mx-1">Your path to financial freedom start here <br/>Grow your investment future with our experts investment plans</p>
                <div className = "grid  grid-cols-1  sm:grid-cols-2 md:grid-cols-3 items-center justify-center gap-4`">
                        <Plan toDeposit = {toDeposit} styles = "mx-5 self-center justify-self-center my-4" investmentAmount = "500" maximumInvestment = "5000" monthlyPercentage= "300%" dailyPercentage = "15%" days = "10 days"/>
                        <Plan toDeposit = {toDeposit} styles = "mx-5 self-center justify-self-center my-4" investmentAmount = "1500" maximumInvestment = "15000" monthlyPercentage= "500%" dailyPercentage = "35%" days = "7 days"/>
                        <Plan toDeposit = {toDeposit} styles = "mx-5 self-center justify-self-center my-4" investmentAmount = "25000" maximumInvestment = "250000" monthlyPercentage= "900%" dailyPercentage = "70%" days = "5 days"/>
                </div>
            </div>
        </>
    ); 
}
 export default InvestmentPlan; 
